// extracted by mini-css-extract-plugin
module.exports = {"quoteBlock":"_1qzmQ","quoteBg":"wyw_k","quoteTriangle":"_2R5vq","byLine":"aDGuF"};